// import React from "react";

// const statusColors = {
//   pending: "bg-yellow-100 text-yellow-800 border border-yellow-300",
//   approved: "bg-green-100 text-green-800 border border-green-300",
//   rejected: "bg-red-100 text-red-800 border border-red-300",
// };

// const StatusBadge = ({ status }) => {
//   const normalizedStatus = status?.toLowerCase();
//   const colorClass = statusColors[normalizedStatus] || "bg-gray-100 text-gray-800 border border-gray-300";

//   return (
//     <span
//       className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap capitalize ${colorClass}`}
//     >
//       {status}
//     </span>
//   );
// };

// export default StatusBadge;

import React from "react";

const statusColors = {
  pending: "bg-yellow-500 text-white shadow-md",
  approved: "bg-[#10B981] text-white shadow-md",
  "campaign created": "bg-purple-800 text-white shadow-md",
  reverted: "bg-red-500 text-white shadow-md",
  "on hold": "bg-blue-700 text-white shadow-md",
  hold: "bg-blue-500 text-white shadow-md",
  active: "bg-[#10B981] text-white shadow-md",
  inactive: "bg-red-400 text-white shadow-md",
  rejected: "bg-red-500 text-white shadow-md",
  cancelled: "bg-red-600 text-white shadow-md",
  draft: "bg-gray-100 text-gray-800 shadow-md",
  paid: "bg-blue-100 text-blue-800 shadow-md",
  processed: "bg-purple-100 text-purple-800 shadow-md",
  generated: "bg-indigo-100 text-indigo-800 shadow-md",
  processing: "bg-orange-100 text-orange-800 shadow-md",
  shortlisted: "bg-[#10B981] text-white shadow-md",
  selected: "bg-blue-500 text-white shadow-md",
  scheduled: "bg-yellow-500 text-white shadow-md",
  completed: "bg-[#10B981] text-white shadow-md",
  "offer sent": "bg-[#9d7b56] text-white shadow-md",
  "offer accepted": "bg-[#72639c] text-white shadow-md",
  present: "bg-[#10B981] text-white shadow-md",
  absent: "bg-red-500 text-white shadow-md",
  "week off": "bg-amber-500 text-white shadow-md",
};

const StatusBadge = ({ status }) => {
  // Handle non-string values (booleans, numbers, etc.)
  let statusString = status;
  if (typeof status === "boolean") {
    statusString = status ? "active" : "inactive";
  } else if (typeof status === "number") {
    statusString = status === 1 || status === true ? "active" : "inactive";
  } else if (status != null) {
    statusString = String(status);
  } else {
    statusString = "inactive";
  }

  const normalizedStatus = statusString?.toLowerCase();
  const colorClass =
    statusColors[normalizedStatus] ||
    "bg-gray-100 text-gray-800 border border-gray-300";

  return (
    <span
      className={`px-4 py-1 rounded-full text-xs font-semibold whitespace-nowrap capitalize shadow-sm ${colorClass}`}
    >
      {statusString}
    </span>
  );
};

export default StatusBadge;
